import React from 'react'
import searchIcon from "../../asset/images/search-icon.svg"
import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { AESEncryption, ApiResDecrypt, copyTextNew, formatDate, mobileVal, noDataFound, onlyNumber } from '../../CommonMethhods/CommonMethods';
import AttachmentFile from "../../asset/images/Vector.svg";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Hni_Admin_Api } from '../../Configuration/API_URL';
import Loader from '../../Components/Common/Loader';
import SmallLoader from '../../Components/Common/smallLoader';
import { useDebounce } from '../../Components/useDebounce';
import contentcopy from '../../asset/images/copy-link.svg'
import LoaderForSearch from '../../Components/Common/LoaderForSearch';

const GeneralLink = () => {
  const storeToken = localStorage.getItem("ssoToken");
  const getRole = localStorage.getItem("cosmosProjectRole");
  const [statusFilter, setStatusFilter] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [dpcData, setDpcData] = useState([]);
  const [mtfData, setMtfData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [loader, setLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchField, setSerchField] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [allPackData, setAllPackData] = useState([]);
  const [actionVal, setActionVal] = useState({});
  const [remarkVal, setRemarkVal] = useState("");
  const [insertLoader, setInsertLoader] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [prefieldVal, setPrefieldVal] = useState(false);
  const [link, setLink] = useState({});
  const navigate = useNavigate();

  const debouncedValue = useDebounce(searchInput, 1000);

  useEffect(() => {
    handleSearchChange(debouncedValue);
  }, [debouncedValue]);

  const brokerageFilter = Yup.object().shape({
    delivery: Yup.string().required("Delivery is required").typeError("typeError"),
    intraday: Yup.string().required("Intraday is required").typeError("typeError"),
    futures: Yup.string().required("Futures is required").typeError("typeError"),
    options: Yup.string().required("Options are required").typeError("typeError"),
    mtf: Yup.string().required("MTF is required"),
    dpc: Yup.string().required("DPC is required"),
    approvalLetter: Yup.string().required("Approval letter is required"),
  });

  const { register, handleSubmit, trigger, formState: { errors, isValid }, setValue, reset: resetForm } = useForm({
    mode: "onChange",
    resolver: yupResolver(brokerageFilter),
  });


  const getGeneralDetails = async (value = "", type, limit) => {
    if (type === "grid" && offset > 0) {
      setLoader(false)
    }
    else if (type === "excel") {
      setSmallLoaderExcel(true);
    } else {
      setLoader(true);
    }
    let payloadValue = {
      format: type,
      search: value,
      offset: offset,
      limit: limit
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getStockDetails = await axios.post(
        Hni_Admin_Api.getGeneralDetail,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getStockDetails?.data);
      if (res?.status === 0) {
        setActionVal({})
        setRemarkVal("");
        setCount(res?.data?.totalCount)
        if (type === "grid") {
          if (offset > 0) {
            setFilteredData((prev) => {
              return [...prev, ...res?.data?.generalDetails];
            })
          } else {
            setTableData(res?.data?.generalDetails);
            setFilteredData(res?.data?.generalDetails);
          }
        }
        else if (type === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (type === "grid") {
          setFilteredData([])
          setTableData([])
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    } finally {
      if (type === "excel") {
        setSmallLoaderExcel(false);
      }
      else {
        setLoader(false);
        setScrollLoader(false);
      }
    }
  };

  useEffect(() => {
    getGeneralDetails(searchInput, "grid", 5);
  }, [offset]);

  const getDpcListData = async () => {
    let payloadValue = {
      offset: 0,
      limit: -1
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDpc = await axios.post(
        Hni_Admin_Api.getDpcList,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getDpc?.data);
      if (res?.status === 0) {
        setDpcData(res?.data?.dpcList);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getMtfListData = async () => {
    let payloadValue = {
      offset: 0,
      limit: -1
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getMtf = await axios.post(
        Hni_Admin_Api.getMtfList,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getMtf?.data);
      if (res?.status === 0) {
        setMtfData(res?.data?.mtfList);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const getAllPackDetails = async () => {
    try {
      const getPackData = await axios.get(
        Hni_Admin_Api.getPackDetails,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getPackData?.data);
      if (res?.status === 0) {
        setAllPackData(res?.data);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    if (getRole === "RM") {
      getAllPackDetails();
      getDpcListData();
      getMtfListData();
    }
  }, []);

  const insertGeneralTableData = async (data) => {
    setInsertLoader(true);
    let payload = {
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: parseInt(data?.mtf),
      dpc: parseInt(data?.dpc),
      // approvalLetter: data?.approvalLetter
      approvalLetter: fileUrl
    }
    let encPayload = AESEncryption(payload);
    try {
      const getData = await axios.post(
        Hni_Admin_Api.insertGeneralDetail,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getData?.data);
      if (res?.status === 0) {
        toast.success("Brokerage details saved successfully!");
        getGeneralDetails("", "grid", 5);
        resetButton();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    } finally {
      setInsertLoader(false);
    }
  };

  const updateRemarksData = async (item) => {
    let payloadValue = {
      id: item?.id,
      remarks: remarkVal,
      status: actionVal[item?.id]
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRemark = await axios.put(
        Hni_Admin_Api.updateGeneralRemarks,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRemark?.data);
      if (res?.status === 0) {
        toast.success(res?.data);
        getGeneralDetails("", "grid", 5);
        setActionVal("")
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const uploadOnAwsApi = async (file, fileType) => {
    try {
      const formData = new FormData();
      formData.append("fileData", file[0]);

      const declarationData = await axios.post(
        Hni_Admin_Api.uploadDocOnAwsFile,
        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = declarationData?.data;
      if (res?.status === 0) {
        setFileUrl(res?.data?.fileName);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      // setUploadGstLoader(false);
    }
  };

  const updateGeneralDetailData = async (data) => {
    let payloadValue = {
      id: data?.id,
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: data?.mtf,
      dpc: data?.dpc,
      approvalLetter: data?.approvalLetter
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getUpdatedRes = await axios.put(
        Hni_Admin_Api.updateGeneralDetails,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getUpdatedRes?.data);
      if (res?.status === 0) {
        toast.success(res?.data);
        getGeneralDetails("", "grid", 5);
        resetButton();
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  function resetButton() {
    resetForm({
      delivery: "",
      intraday: "",
      futures: "",
      options: "",
      mtf: "",
      dpc: "",
      approvalLetter: ""
    })
    setPrefieldVal(false);
  }

  const handleFilterChange = (status) => {
    setStatusFilter(status);
    if (status === '') {
      setFilteredData(tableData);
    }
    else {
      const filtered = tableData.filter(item => item?.status === status);
      setFilteredData(filtered);
    }
  };

  const generateHniLink = async (item) => {
    let payloadValue = {
      rmCode: item?.rmCode,
      id: item?.id
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRemark = await axios.post(
        Hni_Admin_Api.generateGeneralLink,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getRemark?.data);
      if (res?.status === 0) {
        setLink((prevLinks) => ({
          ...prevLinks,
          [item?.id]: res?.data,
        }));
      }else{
        toast.error(res?.message)
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        navigate("/");
      }
    }
  };

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (count != filteredData.length) {
        setScrollLoader(true);
        setOffset((prev) => prev + 1);
        setLoader(false);
      }
    }
  };
  const handleDownloadBtn = () => {
    getGeneralDetails(searchInput, "excel", -1)
  }

  function editTable(data) {
    resetForm({
      id: data?.id,
      delivery: data?.delivery,
      intraday: data?.intraday,
      futures: data?.futures,
      options: data?.options,
      mtf: data?.mtf,
      dpc: data?.dpc,
      status: data?.status,
      remarks: data?.remarks,
      approvalLetter: data?.approvalLetterName || fileUrl
    })
    setPrefieldVal(true);
  }

  const handleSearchChange = (data) => {
    if (data) {
      getGeneralDetails(data, "grid", 5);
    }
    else if (searchField === true) {
      getGeneralDetails("", "grid", 5);
      // setFilteredData([])
    }
    setOffset(0);
  };


  const handleFileUpload = (e, fileType) => {
    const MAX_FILE_SIZE = 1048576 * 5;
    const file = e?.target?.files?.[0];
    if (!file) return;
    if (file.size > MAX_FILE_SIZE) {
      setValue(fileType, "");
      toast.error("Please select a file less than 5MB");
      return;
    }
    uploadOnAwsApi(e?.target?.files, fileType);
    setValue(fileType, file?.name, { shouldValidate: true });
    trigger(fileType);
  };

  const onSubmit = (data) => {
    if (prefieldVal === true) {
      updateGeneralDetailData(data);
    } else {
      insertGeneralTableData(data);
    }
  };

  const handleAction = (val, id) => {
    setActionVal(prevState =>({
      ...prevState,
      [id]: val
    }));
  }

  const handleRemark = (e) => {
    setRemarkVal(e?.target?.value)
  }

  const handleSubmitRemark = (item) => {
    updateRemarksData(item)
  }

  // const copyLinkToClipboard = (mobileNo) => {
  //   const linkToCopy = link[mobileNo];
  //   if (linkToCopy) {
  //     navigator.clipboard.writeText(linkToCopy).then(
  //       () => {
  //         toast.success("Link copied to clipboard!");
  //       },
  //       (error) => {
  //         toast.error("Failed to copy the link.");
  //       }
  //     );
  //   }
  // };

  const ascendingOrder = (column) => {
    const sortedList = [...filteredData].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return a[column].localeCompare(b[column] || "");
      } else {
        return a[column] - b[column];
      }
    });
  
    setFilteredData(sortedList);
  };

  const descendingOrder = (column) => {
    const sortedList = [...filteredData].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return b[column].localeCompare(a[column] || "");
      } else {
        return b[column] - a[column];
      }
    });
    setFilteredData(sortedList);
  };


  return (
    <>
      {getRole === "Admin" ?
        <div className='personal-page brokerage'>
          <div className='personal-wrapper'>
            <div className="personal-buttons-wrapper">
              <button
                type="button"
                className={`${statusFilter === "Pending" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Pending')}
                // disabled={getRole !== "Admin"}
              >
                Pending
              </button>

              <button
                type="button"
                className={`${statusFilter === "Approved" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Approved')}
                // disabled={getRole !== "Admin"}
              >
                Approved
              </button>

              <button
                type="button"
                className={`${statusFilter === "Rejected" ? "selected-button" : "personal-buttons"}`}
                onClick={() => handleFilterChange('Rejected')}
                // disabled={getRole !== "Admin"}
              >
                Rejected
              </button>
            </div>

            <div className='search-input-wrapper'>
              <div className="rm-custom-dropdown">
                <img src={searchIcon} alt="search" />

                  <input
                    type="text"
                    name="search-text"
                    className="input-st ap"
                    value={searchInput}
                    onInput={onlyNumber}
                    maxLength={6}
                    placeholder="Search by RM code"
                    autoComplete="off"
                    onChange={(e) => {
                      setSearchInput(e?.target?.value?.toLowerCase());
                      setSerchField(true)
                    }}
                  />

              </div>

              <button className="dnload-btn" onClick={handleDownloadBtn}>
                  {smallLoaderExcel ? (
                    <SmallLoader />
                  ) :
                    <>
                      <img src={downloadbrokrage} alt="download" />
                      Download All</>
                  }
                </button>
            </div>
          </div>

          <div className='brokerage-table'>
          {loader ? (
              <Loader />
            ) :
            <div className="scroll-table master_table personalised-table general-table">
              {filteredData && filteredData?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <span className='wrap-th'>
                        <span>Sr. No</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>RM Code</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("rmCode")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("rmCode")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>RM Name</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("rmName")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("rmName")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Delivery</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("delivery")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("delivery")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Intraday</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("intraday")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("intraday")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Futures</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("futures")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("futures")}
                          ></span>
                        </span>
                      </span></th>
                    <th><span className='wrap-th'>
                      <span>Options</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("options")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("options")}
                        ></span>
                      </span>
                    </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>DPC</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("dpc")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("dpc")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>MTF</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("mtf")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("mtf")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Created Date</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("createdDate")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("createdDate")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Approval Letter</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Status</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("status")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("status")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Actions</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Remarks</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Confirm Action</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody onScroll={(e) => handleScroll(e)} id="per-table-body">
                      {filteredData?.length > 0 && filteredData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.rmCode}</td>
                          <td>{item?.rmName}</td>
                          <td>₹{item?.delivery}</td>
                          <td>₹{item?.intraday}</td>
                          <td>₹{item?.futures}</td>
                          <td>₹{item?.options}</td>
                          <td>{item?.dpc}%</td>
                          <td>{item?.mtf}%</td>
                          <td>{formatDate(item?.createdDate) || "-"}</td>
                          <td className='text-blue-dark' style={{cursor: "pointer"}}>
                            <div className='d-flex align-items-center'>
                              <div
                                onClick={() => {
                                  window.open(
                                    item?.approvalLetter,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                }}
                                className="tagAnchor"
                              >
                                {item?.approvalLetterName}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className={`status-label ${item?.status === 'Pending' ? 'text-yellow' :
                              item?.status === 'Approved' ? 'text-green bg-light-green-new' : 'txt-red bg-light-red-new'}`}>
                              {item?.status}
                            </div>
                          </td>
                          <td>
                            <div className='action-wrapper'>
                              <button 
                              className={`${(actionVal[item?.id] === "Approved" || item?.status == "Approved") ? 
                                "text-white bg-green status-label no-drop-cursor" : 
                                item?.status === "Rejected" ? "disabled-text-approve status-label no-drop-cursor" :
                                "disabled-text-approve status-label"}`}
                                type='button'
                                onClick={() => handleAction("Approved", item?.id)}
                              >
                                Approve
                              </button>

                              <button 
                              className={`${actionVal[item?.id] === "Rejected" || item?.status === "Rejected" ? 
                              "text-white bg-red status-label no-drop-cursor" : 
                              item?.status === "Approved" ? "disabled-text-reject status-label no-drop-cursor" :
                              "disabled-text-reject status-label"}`}
                                type='button'
                                onClick={() => handleAction("Rejected", item?.id)}
                              >
                                Reject
                              </button>
                            </div>
                          </td>

                          <td>
                            <input
                              className={`${!actionVal[item?.id] ? "disable-remark" : 'remark-input'}`}
                              type='text'
                              placeholder='Add Remarks'
                              onChange={(e) => handleRemark(e)}
                              onInput={(e) =>
                                (e.target.value = e.target.value.replace(/^\s+/, "").toUpperCase())
                              }
                              disabled={!actionVal[item?.id]}
                            />
                            {actionVal[item?.id] === "Rejected" &&
                              <span className="star_text">*</span>
                            }
                          </td>

                          <td>
                            <button
                              type="button"
                              className="submit-buttons"
                              onClick={() => handleSubmitRemark(item)}
                              disabled={(item?.status === "Pending" && remarkVal?.length == 0 && actionVal[item?.id] !== "Approved")
                                || item?.status === "Rejected" || item?.status === "Approved"}
                            >
                              Submit
                            </button>
                          </td>
                        </tr>
                      ))
                      }
                    </tbody>
              </table>
              ) : noDataFound()
            }
            </div>
          }
          </div>
        </div>
        :
        getRole === "RM" ?
        <div className='personal-page brokerage'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-label brokerage-title">
              Select Brokerage</div>
            <div className='row input-field-wrapper'>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Delivery
                    <span className="star_text">*</span>
                  </label>
                  <select
                    className={`report-custom-select personalised-select 
                    ${errors?.delivery && errors?.delivery?.message !== "typeError" ? "invalid" : ""}`}
                    {...register("delivery")}
                  >
                    <option value="">Select Delivery</option>
                    {allPackData?.delivery?.length > 0 && allPackData?.delivery?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Intraday
                    <span className="star_text">*</span>
                  </label>
                  <select
                  className={`report-custom-select personalised-select 
                  ${errors?.intraday && errors?.intraday?.message !== "typeError" ? "invalid" : ""}`}
                    {...register("intraday")}
                  >
                    <option value="">Select Intraday</option>
                    {allPackData?.intraday?.length > 0 && allPackData?.intraday?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Futures
                    <span className="star_text">*</span>
                  </label>
                  <select
                    className={`report-custom-select personalised-select 
                    ${errors?.futures && errors?.futures?.message !== "typeError" ? "invalid" : ""}`}
                    {...register("futures")}
                  >
                    <option value="">Select Futures</option>
                    {allPackData?.futures?.length > 0 && allPackData?.futures?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Options (per lot)
                    <span className="star_text">*</span>
                  </label>
                  <select
                    className={`report-custom-select personalised-select 
                    ${errors?.options && errors?.options?.message !== "typeError" ? "invalid" : ""}`}
                    {...register("options")}
                  >
                    <option value="">Select Options</option>
                    {allPackData?.options?.length > 0 && allPackData?.options?.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">MTF
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                  ${errors?.mtf && errors?.mtf?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("mtf")}
                    >
                      <option value="">Select MTF</option>
                      {mtfData?.length > 0 && mtfData?.map((item) => (
                        <option value={item?.perc}>{item?.perc}%</option>
                      ))}
                    </select>
                    {
                      errors?.mtf && errors?.mtf?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.mtf?.message}
                      </p>
                    }
                  </div>
                </div>
              <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">DPC
                      <span className="star_text">*</span>
                    </label>
                    <select
                      className={`report-custom-select personalised-select 
                    ${errors?.dpc && errors?.dpc?.message !== "typeError" ? "invalid" : ""}`}
                      {...register("dpc")}
                    >
                      <option value="">Select DPC</option>
                      {dpcData?.length > 0 && dpcData?.map((item) => (
                        <option value={item?.perc}>{item?.perc}%</option>
                      ))}

                    </select>
                    {
                      errors?.dpc && errors?.dpc?.message !== "typeError" &&
                      <p className="ErrorMsg">
                        {errors?.dpc?.message}
                      </p>
                    }
                  </div>
                </div>

              <div className="col-md-4 col-sm-4 col-12">
                <div className="form-group">
                  <label className="form-label">
                    Upload Approval Letter
                    <span className="star_text">*</span>
                  </label>
                  <div className="custom-upload">
                    <input
                      className="f-input input-st ap upload-doc"
                      placeholder="Upload File"
                      {...register('approvalLetter')}

                    />
                    <div className="fileUpload btn btn--browse upload-doc">
                      <img
                        src={AttachmentFile}
                        alt="attachment"
                        className
                      />
                      <span>Browse File</span>
                      <input
                        type="file"
                        readOnly
                        className="upload"
                        accept=".pdf,.png,.jpg,.jpeg"
                        onChange={(e) => { handleFileUpload(e, "approvalLetter") }}

                      />
                    </div>
                  </div>
                  <div className="ErrorMsg">
                    {/* {errors.inputFileGst?.message} */}
                  </div>
                  <span className="limit-text">
                    File format: png, jpg, jpeg & pdf. Maximum file size: 5 MB
                  </span>
                </div>
              </div>

            </div>

            <div className="brokerage-btn-section">
              <button type="submit"
                className={`${!isValid ? "personalise-btn-disabled" :"brokerage-save-btn"}`}
                disabled={!isValid} >
                  {insertLoader ?
                    <SmallLoader />
                    :
                    <>Generate Link</>
                  }
              </button>
            </div>
          </form>
          <div className='personal-wrapper'>
          <div className='search-input-wrapper'>
            <button className="dnload-btn" onClick={handleDownloadBtn}>
                  {smallLoaderExcel ? (
                    <SmallLoader />
                  ) :
                    <>
                      <img src={downloadbrokrage} alt="download" />
                      Download All</>
                  }
                </button>
                </div>
          </div>

          <div className='brokerage-table'>
          {loader ? (
                <Loader />
              ) :
            <div className="scroll-table master_table personalised-table">
              {filteredData && filteredData?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <span className='wrap-th'>
                        <span>Sr. No</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Delivery</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("delivery")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("delivery")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Intraday</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("intraday")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("intraday")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Futures</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("futures")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("futures")}
                          ></span>
                        </span>
                      </span></th>
                    <th><span className='wrap-th'>
                      <span>Options</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                        onClick={() => descendingOrder("options")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                        onClick={() => ascendingOrder("options")}
                        ></span>
                      </span>
                    </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>DPC</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("dpc")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("dpc")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>MTF</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("mtf")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("mtf")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Created Date</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("createdDate")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("createdDate")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Approval Letter</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Status</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                          onClick={() => descendingOrder("status")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                          onClick={() => ascendingOrder("status")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    
                    <th>
                      <span className='wrap-th'>
                        <span>Remarks</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Edit Details</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Generate Link</span>
                      </span>
                    </th>
                    <th>
                      <span className='wrap-th'>
                        <span>Copy Link</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody onScroll={(e) => handleScroll(e)} id="per-table-body">
                  {filteredData?.length > 0 && filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.delivery}</td>
                      <td>{item?.intraday}</td>
                      <td>{item?.futures}</td>
                      <td>{item?.options}</td>
                      <td>{item?.dpc}</td>
                      <td>{item?.mtf}</td>
                      <td>{formatDate(item.createdDate) || "-"}</td>
                      <td className='text-blue-dark' style={{cursor: "pointer"}}>
                            <div className='d-flex align-items-center'>
                              <div
                                onClick={() => {
                                  window.open(
                                    item?.approvalLetter,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                }}
                                className="tagAnchor"
                              >
                                {item?.approvalLetterName}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className={`status-label ${item?.status === 'Pending' ? 'text-yellow' :
                              item?.status === 'Approved' ? 'text-green bg-light-green-new' : 'txt-red bg-light-red-new'}`}>
                              {item?.status}
                            </div>
                          </td>
                          <td>
                              {item?.remarks || "-"}
                            </td>
                            <td>
                              <button
                                onClick={() => editTable(item)}
                                type="button"
                                className={`${item?.status !== "Rejected" ? "disable-submit-btn" : "submit-buttons"}`}
                                disabled={item?.status !== "Rejected"}
                              >
                                Edit Details
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className={`${item?.status !== "Approved" ? "disable-submit-btn" : "submit-buttons"}`}
                                disabled={item?.status !== "Approved"}
                                onClick={() => generateHniLink(item)}
                              >
                                {link[item?.id] ? "Generated" : "Generate Link"}
                              </button>
                            </td>
                            <td className='general-td'>
                              <button
                                type="button"
                                className={`${item?.status !== "Approved" || !link[item?.id] ? "copy-btn" : "copy-btn"}`}
                                disabled={item?.status !== "Approved" || !link[item?.id]}
                                id={'modifyreqest' + index}
                                onClick={(e) => copyTextNew(e, '#modifyreqest' + index, 'modifytested' + index, link[item?.id])}
                                data-toggle="tooltip" 
                                data-placement="top"
                              >
                                <span id={'modifytested' + index} className="copy-txt">
                                  {link[item?.id]}
                                </span>
                                <span >
                                  <img src={contentcopy} alt="contentcopy" height={"13"} width={"13px"} />
                                  Copy Link
                                </span>
                              </button>
                            </td>
                    </tr>
                  ))
                  }
                  {scrollLoader && (
                    <div className="loader-center">
                      <LoaderForSearch />
                    </div>
                  )}
                </tbody>
              </table>
              ) : noDataFound()
            }
            </div>
          }
          </div>
        </div>
        : 
        <div className='brokerage-table'>
            {noDataFound()}
          </div>
      }
    </>
  )
}

export default GeneralLink;